import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Benutzer } from '../types'

interface AuthState {
  user: Benutzer | null
  token: string | null
  login: (user: Benutzer, token: string) => void
  logout: () => void
  isLoggedIn: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      login: (user, token) => {
        localStorage.setItem('vx_token', token)
        set({ user, token })
      },
      logout: () => {
        localStorage.removeItem('vx_token')
        set({ user: null, token: null })
      },
      isLoggedIn: () => get().user !== null,
    }),
    {
      name: 'vaporex-auth',
      partialize: (state) => ({ user: state.user, token: state.token }),
    }
  )
)
